import styled from 'styled-components';

const StyledPeopleGridWrap = styled.div`
  position: relative;
  padding: 0 64px;
  margin-bottom: ${props => props.theme.components_spacing_desk.xxlarge}px;
  h4{
    padding-bottom: ${props => props.theme.components_spacing_desk.large}px;
  }
  @media screen and (max-width: 1439px){
    padding: 0 40px;
    h4{
      padding-bottom: ${props => props.theme.components_spacing_tablet.large}px;
    }
  }
  @media screen and (max-width: 1023px){
    margin-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
  }
  @media screen and (max-width: 767px){
    padding: 0 24px;
    margin-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    h4{
      padding-bottom: ${props => props.theme.components_spacing_mobile.large}px;
    }
  }
`;

export {
  StyledPeopleGridWrap,
};

